module.exports = __webpack_public_path__ + "assets/img/default-avatar.e39ef0ae.png";